function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('saito-js/lib/util'),
  fromBase58 = _require.fromBase58;
var Saito = require('saito-js/saito')["default"];
var _require2 = require('./timestamp-diagnostics'),
  logExplorerTimestampComparison = _require2.logExplorerTimestampComparison;
var BURNFEE_MULTIPLIER = 100000000;
var FORK_DELAY_MODULUS_MS = 5000;
var MIN_SLEEP_MS = 500;
var MAX_SLEEP_MS = 60000;
function toBigInt(value) {
  try {
    if (value == null || value === '') {
      return 0n;
    }
    return BigInt(value);
  } catch (err) {
    return 0n;
  }
}
function getHeartbeatMs(app) {
  var _app$options;
  var heartbeat = Number(app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.consensus) === null || _app$options === void 0 ? void 0 : _app$options.heartbeat_interval);
  if (Number.isFinite(heartbeat) && heartbeat > 0) {
    return heartbeat;
  }
  return 30000;
}

/**
 * Mirror BurnFee::return_routing_work_needed_to_produce_block_in_nolan (nolan units).
 */
function routingWorkNeeded(burnfeeNolan, currentTs, previousTs, heartbeatMs) {
  var previous = Number(previousTs);
  var current = Number(currentTs);
  if (!Number.isFinite(previous) || !Number.isFinite(current) || previous >= current) {
    logExplorerTimestampComparison(previousTs, currentTs, {
      source: 'routingWorkNeeded (previous >= current)'
    });
    return Number.MAX_SAFE_INTEGER;
  }
  var elapsed = Math.max(current - previous, 1);
  if (elapsed >= 2 * heartbeatMs) {
    return 0;
  }
  var burnfee = Number(burnfeeNolan) / BURNFEE_MULTIPLIER;
  var workNeeded = burnfee / elapsed;
  return Math.round(workNeeded * BURNFEE_MULTIPLIER);
}
function computeRoutingWorkForNode(totalFeesNolan) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var nodePublicKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!path.length || !nodePublicKey || totalFeesNolan <= 0n) {
    return 0n;
  }
  var lastHop = path[path.length - 1];
  var lastTo = String((lastHop === null || lastHop === void 0 ? void 0 : lastHop.to) || '');
  if (lastTo !== nodePublicKey) {
    return 0n;
  }
  var work = totalFeesNolan;
  for (var i = 1; i < path.length; i++) {
    work /= 2n;
  }
  return work;
}
function getMempoolRoutingWork(_x, _x2) {
  return _getMempoolRoutingWork.apply(this, arguments);
}
/**
 * Mirror mempool can_bundle_block fork-delay check (pubkey + previous block hash).
 */
function _getMempoolRoutingWork() {
  _getMempoolRoutingWork = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, nodePublicKey) {
    var txs, work, i, tx, fees, path;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return Saito.getInstance().getMempoolTxs();
        case 1:
          txs = _context.v;
          work = 0n;
          for (i = 0; i < txs.length; i++) {
            tx = txs[i];
            fees = toBigInt(tx === null || tx === void 0 ? void 0 : tx.total_fees);
            path = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.routing_path) ? tx.routing_path : [];
            work += computeRoutingWorkForNode(fees, path, nodePublicKey);
          }
          return _context.a(2, work);
      }
    }, _callee);
  }));
  return _getMempoolRoutingWork.apply(this, arguments);
}
function computeForkDelayMs(app, publicKey, previousBlockHash) {
  if (!publicKey || !previousBlockHash) {
    return 0;
  }
  try {
    var pkHex = fromBase58(publicKey);
    var combined = Buffer.concat([Buffer.from(pkHex, 'hex'), Buffer.from(String(previousBlockHash), 'hex')]);
    var hashHex = app.crypto.hash(combined);
    var hashBytes = Buffer.from(hashHex, 'hex');
    var start = Math.max(0, hashBytes.length - 16);
    var low128 = 0n;
    for (var i = start; i < hashBytes.length; i++) {
      low128 = low128 << 8n | BigInt(hashBytes[i]);
    }
    return Number(low128 % BigInt(FORK_DELAY_MODULUS_MS));
  } catch (err) {
    return 0;
  }
}
function clampSleepMs(ms) {
  if (!Number.isFinite(ms) || ms <= 0) {
    return MIN_SLEEP_MS;
  }
  return Math.max(MIN_SLEEP_MS, Math.min(MAX_SLEEP_MS, Math.ceil(ms)));
}

/**
 * Estimate milliseconds until burn-fee timing (and fork-delay) likely allow bundling.
 */
function estimateBundleWaitMs(_ref) {
  var now = _ref.now,
    previousBlockTs = _ref.previousBlockTs,
    burnfeeNolan = _ref.burnfeeNolan,
    heartbeatMs = _ref.heartbeatMs,
    workAvailableNolan = _ref.workAvailableNolan,
    forkDelayMs = _ref.forkDelayMs;
  var previous = Number(previousBlockTs);
  var heartbeatReadyAt = previous + 2 * heartbeatMs;
  var forkReadyAt = previous + Number(forkDelayMs || 0);
  var workReadyAt = now;
  var workAvailable = Number(workAvailableNolan);
  var burnfee = Number(burnfeeNolan);
  if (workAvailable > 0 && burnfee > 0) {
    var neededElapsed = Math.ceil(burnfee / workAvailable);
    workReadyAt = previous + neededElapsed;
  } else if (workAvailable <= 0) {
    workReadyAt = heartbeatReadyAt;
  }
  var readyAt = Math.max(heartbeatReadyAt, forkReadyAt, workReadyAt);
  return clampSleepMs(readyAt - now);
}
function canBundleNow(_ref2) {
  var now = _ref2.now,
    previousBlockTs = _ref2.previousBlockTs,
    burnfeeNolan = _ref2.burnfeeNolan,
    heartbeatMs = _ref2.heartbeatMs,
    workAvailableNolan = _ref2.workAvailableNolan,
    forkDelayMs = _ref2.forkDelayMs,
    mempoolHasTx = _ref2.mempoolHasTx;
  if (!mempoolHasTx) {
    return false;
  }
  var workNeeded = routingWorkNeeded(burnfeeNolan, now, previousBlockTs, heartbeatMs);
  var workAvailable = Number(workAvailableNolan);
  if (workAvailable < workNeeded) {
    return false;
  }
  var previous = Number(previousBlockTs);
  if (now < previous + Number(forkDelayMs || 0)) {
    return false;
  }
  return true;
}
function analyzeBundleReadiness(_x3) {
  return _analyzeBundleReadiness.apply(this, arguments);
}
function _analyzeBundleReadiness() {
  _analyzeBundleReadiness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
    var now, heartbeatMs, publicKey, blocks, latest, previousBlockTs, burnfeeNolan, forkDelayMs, mempoolTxs, mempoolHasTx, workAvailableNolan, readiness;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          now = Date.now();
          heartbeatMs = getHeartbeatMs(app);
          _context2.n = 1;
          return app.wallet.getPublicKey();
        case 1:
          publicKey = _context2.v;
          _context2.n = 2;
          return app.core.blockchain.getBlocks(1, false);
        case 2:
          blocks = _context2.v;
          latest = Array.isArray(blocks) && blocks.length ? blocks[0] : null;
          if (latest) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, {
            now: now,
            previousBlockTs: 0,
            burnfeeNolan: 0n,
            heartbeatMs: heartbeatMs,
            workAvailableNolan: 0n,
            forkDelayMs: 0,
            mempoolHasTx: false,
            mempoolTxCount: 0,
            canBundleNow: false,
            waitMs: heartbeatMs
          });
        case 3:
          previousBlockTs = Number(latest.timestamp);
          burnfeeNolan = toBigInt(latest.burnFee);
          forkDelayMs = computeForkDelayMs(app, publicKey, latest.hash);
          _context2.n = 4;
          return Saito.getInstance().getMempoolTxs();
        case 4:
          mempoolTxs = _context2.v;
          mempoolHasTx = mempoolTxs.length > 0;
          _context2.n = 5;
          return getMempoolRoutingWork(app, publicKey);
        case 5:
          workAvailableNolan = _context2.v;
          readiness = {
            now: now,
            previousBlockTs: previousBlockTs,
            burnfeeNolan: burnfeeNolan,
            heartbeatMs: heartbeatMs,
            workAvailableNolan: workAvailableNolan,
            forkDelayMs: forkDelayMs,
            mempoolHasTx: mempoolHasTx
          };
          return _context2.a(2, {
            now: now,
            previousBlockTs: previousBlockTs,
            burnfeeNolan: burnfeeNolan,
            heartbeatMs: heartbeatMs,
            workAvailableNolan: workAvailableNolan,
            forkDelayMs: forkDelayMs,
            mempoolHasTx: mempoolHasTx,
            mempoolTxCount: mempoolTxs.length,
            canBundleNow: canBundleNow(_objectSpread(_objectSpread({}, readiness), {}, {
              mempoolHasTx: mempoolHasTx
            })),
            waitMs: estimateBundleWaitMs(readiness)
          });
      }
    }, _callee2);
  }));
  return _analyzeBundleReadiness.apply(this, arguments);
}
module.exports = {
  getHeartbeatMs: getHeartbeatMs,
  routingWorkNeeded: routingWorkNeeded,
  analyzeBundleReadiness: analyzeBundleReadiness,
  clampSleepMs: clampSleepMs
};